import IEdgeData from "../../database/interfaces/IEdgeData";

/**
 * Egységes „elérhető él" feltétel a configuratorhoz.
 *
 * A configurator SEHOL nem kínál fel és nem választ automatikusan Status ≠ 1 élet
 * (uc_edgeprices.Status a shop-árazásból: 1 = elérhető, 2 = csak rendelésre).
 *
 * Minden él-lista (EdgeContent legördülő, EdgeListContent „+" gomb) ÉS minden auto-választó
 * (edgeAutoSelect: pickBestEdge / él-cserék, board- és duplung-váltás) ezt a közös predikátumot
 * használja. Így a megjelenített opciók és az automatikusan beállított értékek konzisztensek:
 * nem fordulhat elő, hogy egy auto-választott, de a listában nem szereplő (Status ≠ 1) él miatt
 * üresnek látszik a selector.
 */
export const isEdgeAvailable = (edge: IEdgeData): boolean => edge.Status === 1;
